import { ReactNode } from 'react';
import { MARKETING_CONTENT_WIDTH_CLASSNAME } from '../../../utils/marketing-content-width.util';

export function NavBarContainer({ children }: { children: ReactNode }) {
  return (
    <div
      data-name="navbar-container"
      className={`${MARKETING_CONTENT_WIDTH_CLASSNAME} relative flex h-full items-center justify-start py-2 lg:py-0`}
    >
      {children}
    </div>
  );
}
